module.exports = __webpack_public_path__ + "fonts/u2f@2x.f319c2cfac87ba8f0e47ad4d219cd402.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/u2f@2x.png
// module id = 769
// module chunks = 9